

export class GrupoEncabezado{
  id: string;
  titulo: string;
  roles: number[];
}